import React, { useEffect, useState } from 'react'
import { Box, Button } from '@mui/material'
import LeftArrowIcon from '@mui/icons-material/ChevronLeft'
import { useAppSelector } from 'src/store'
import { Ingredient } from '../../../../types/types'
import CategoryIngredientList from '../CategoryIngredientsList'
import './CategoryIngredientToolbar.scss'

export type CategoryIngredientToolbarProps = {
    category: number;
    ingredients: Ingredient[];
}

const CategoryIngredientToolbar = (props: CategoryIngredientToolbarProps) => {

    const { category, ingredients } = props

    const [level, setLevel] = useState(0)

    const STANDARD_LEVEL = 0
    const ADVANCED_LEVEL = 1

    const levelIngredients = ingredients?.filter(x => x.configurable === (level === ADVANCED_LEVEL))
    const selectedIngredients = useAppSelector(x => x.recipes.currentRecipe?.ingredients)

    const [collapsed, setCollapsed] = useState(false)

    useEffect(() => {
        setCollapsed(false)
    }, [category])

    return (
        <Box
            className="category-ingredient-toolbar"
            data-collapsed={collapsed}
        >
            {!collapsed &&
                <CategoryIngredientToolbarHeader
                    level={level}
                    onSelect={(level) => setLevel(level)}
                />
            }
            <Box>
                <CategoryIngredientList
                    collapsed={collapsed}
                    ingredients={levelIngredients}
                    selectedIngredients={selectedIngredients || []}
                    setCollapsed={setCollapsed}
                />
                
                <Box id="collapse-btn"
                    onClick={() => { setCollapsed(!collapsed) }}
                >
                    <LeftArrowIcon />
                </Box>
            </Box>
        </Box>
    )
}

export type CategoryIngredientToolbarHeaderProps = {
    level: number;
    onSelect: (level: number) => void;

}
const CategoryIngredientToolbarHeader = (props: CategoryIngredientToolbarHeaderProps) => {
    const { level } = props
    return (
        <Box className="header">
            <Button variant="text" onClick={() => { props.onSelect(0) }} data-active={level === 0}>Standard</Button>
            <Button variant="text" onClick={() => { props.onSelect(1) }} data-active={level === 1}>Advanced</Button>
            {/* <Button variant="text" onClick={() => { props.onSelect(2) }} data-active={level === 2}>Filters</Button> */}
        </Box>
    )
}


export default CategoryIngredientToolbar